import * as VueCesium from './index'

export default { ...VueCesium }
